
import { Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { IChatQueueItem } from "@tylertech/tyler-api-types";

/**
 * ChatService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ChatService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetChatQueueItems(filterString?: string): Promise<IChatQueueItem[]> {
        return this.$apiService.sendUnauth("IChatService/GetChatQueueItems", null, filterString);
    }
    GetChatQueueNames(): Promise<string[]> {
        return this.$apiService.sendUnauth("IChatService/GetChatQueueNames");
    }
    GetChatUrl(pQueueName: string): Promise<string> {
        return this.$apiService.sendUnauth("IChatService/GetChatUrl", pQueueName);
    }
}
